import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ArrowUp } from 'lucide-react';

/**
 * Global floating "scroll to top" button.
 * Appears bottom-right on every public page after the user scrolls ~400px.
 * Sits above the MobileStickyCTA on small screens (bottom offset adapts).
 * Hidden on /admin routes.
 */
const ScrollToTopButton = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const isAdmin = location.pathname.startsWith('/admin');

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (isAdmin) return null;

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Nach oben scrollen"
      data-testid="scroll-to-top-btn"
      className="scroll-to-top-fab"
      style={{
        position: 'fixed',
        right: '16px',
        zIndex: 60,
        width: '44px',
        height: '44px',
        borderRadius: '9999px',
        background: '#005898',
        color: '#fff',
        boxShadow: '0 6px 18px rgba(0,0,0,0.18)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? 'auto' : 'none',
        transform: visible ? 'translateY(0)' : 'translateY(12px)',
        transition: 'opacity 0.25s ease, transform 0.25s ease',
      }}
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
};

export default ScrollToTopButton;
